import { createSlice } from "@reduxjs/toolkit";

// define state here
const initialState = {
  data: [],
  totalRecords: 0,
  isFetching: false,
  error: null,
};

export const roleOptionData = createSlice({
  name: "roleOptionData",
  initialState,
  reducers: {
    fetchDataBegin: (state) => {
      state.isFetching = true;
      state.error = null;
    },
    fetchDataError: (state, action) => {
      const { message = null } = action.payload;
      state.isFetching = false;
      state.error = message;
    },

    getRoleOptionsDataSuccess: (state, action) => {
      const { newData } = action.payload;
      state.isFetching = false;
      state.data = newData;
      state.totalRecords = newData.length;
    },
  },
});

export const { fetchDataBegin, fetchDataError, getRoleOptionsDataSuccess } =
  roleOptionData.actions;

export const companyDataSelector = (state) => state.roleOptionData.data;

export default roleOptionData.reducer;
